import { render, staticRenderFns } from "./jikaoSj.vue?vue&type=template&id=13bf0c5f&scoped=true"
import script from "./jikaoSj.vue?vue&type=script&lang=js"
export * from "./jikaoSj.vue?vue&type=script&lang=js"
import style0 from "./jikaoSj.vue?vue&type=style&index=0&id=13bf0c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf0c5f",
  null
  
)

export default component.exports